import * as angular from 'angular';
import template from './lineSheetReact.tpl.html';
import component from './lineSheet.react';
import {StateParams} from "../../common";
import {States} from "../../shared/config/constant.module";
import environment, { Environment } from '../../shared/config/environment';


let requires = [component,environment];

export interface LineSheetReactController {
  plantId: string;
  shopId: string;
  userId: string;
  initialDate: Date;
  eightyHrTools: string;
  oneSixtyHrTools: string;
}

export interface LineSheetParams extends StateParams {
  initialDate: string;
}

class LineSheetReactCtrl implements LineSheetReactController {
  plantId: string;
  shopId: string;
  userId: string;
  initialDate: Date;
  eightyHrTools: string;
  oneSixtyHrTools: string;

  constructor($stateParams: LineSheetParams, environment: Environment) {
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;
    this.userId = $stateParams.userId;
    this.initialDate = $stateParams.initialDate ? new Date($stateParams.initialDate) : null;
    this.eightyHrTools = environment.EightyToolset;
    this.oneSixtyHrTools = environment.OneSixtyToolSet;
  }
}

export default angular.module('aps.controller.lineSheet', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.LINE_SHEET,
      url: '/lineSheet?initialDate',
      params: {
        initialDate: {dynamic: true}
      },
      controller: 'LineSheetReactCtrl as vm',
      template: template,
      data: {pageTitle: 'Line Sheet'}
    });
  })
  .controller('LineSheetReactCtrl', LineSheetReactCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/linesheet/lineSheet.controller.ts